import React from 'react';
import Button from './ui/Button';
import FadeIn from './ui/FadeIn';

export default function Hero() {
  return (
    <section className="relative pt-32 pb-16 md:pt-44 md:pb-24 overflow-hidden bg-warmWhite">
      {/* Background Decorative Element */}
      <div className="absolute top-0 right-0 w-1/3 h-1/2 bg-blush/5 blur-[120px] rounded-full -translate-y-1/2 translate-x-1/2" />
      
      <div className="container mx-auto px-6 md:px-12 relative z-10">
        <div className="max-w-4xl mx-auto text-center mb-16 md:mb-20">
          <FadeIn>
            <h1 className="font-heading text-5xl md:text-7xl lg:text-8xl font-bold leading-[1.05] mb-8 text-charcoal tracking-tight">
              Custom Wrapped Vases for <span className="text-blush">Modern Florists.</span>
            </h1>
          </FadeIn>
          
          <FadeIn delay={0.1}>
            <p className="text-lg md:text-2xl text-gray-600 mb-10 font-light leading-relaxed max-w-2xl mx-auto">
              Wholesale vases with curated designs, delivered directly to your shop. Elevate your arrangements with premium branding.
            </p>
          </FadeIn>
          
          <FadeIn delay={0.2}>
            <Button href="https://florist.smilevase.com" className="!px-10 !py-5 !text-base">
              Start Your Order
            </Button>
          </FadeIn>
        </div>
      </div>

      {/* Full Width Landscape Image */}
      <FadeIn delay={0.3} className="w-full px-4 md:px-8 max-w-[1600px] mx-auto">
        <div className="relative aspect-[21/9] w-full rounded-2xl md:rounded-[2rem] overflow-hidden shadow-2xl border border-white/20">
          <img 
            src="https://media-manager-c.questera.ai/greta-media/59ae0bb41770d2469177613915938081754fb6ea2a9fa9dd3795d6aaad98229d6f8726e998ab332e78221477594a4f2f/images/aW1hZ2UvanBlZw==/a0c12ee555525309b2667293be3ae42b.jpeg" 
            alt="SmileVase custom floral vase collection" 
            className="absolute inset-0 w-full h-full object-cover transform hover:scale-105 transition-transform duration-[2s] ease-out"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-charcoal/10 to-transparent pointer-events-none" />
        </div>
      </FadeIn>
    </section>
  );
}